import * as React from "react";
import type { SVGProps } from "react";
const SvgBackpackBadgePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.5 11c0 .55.45 1 1 1s1-.45 1-1V9.5H19c.55 0 1-.45 1-1s-.45-1-1-1h-1.5V6c0-.55-.45-1-1-1s-1 .45-1 1v1.5H14c-.55 0-1 .45-1 1s.45 1 1 1h1.5V11Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 8.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-2 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M10 4a1 1 0 0 1 1-1h1.919c.514 0 .97.329 1.132.816l1.898-.632A3.194 3.194 0 0 0 12.919 1H11a3 3 0 0 0-3 3v.775a7.593 7.593 0 0 0-1.4.807c-1.331.972-2.17 2.263-2.698 3.53-1.042 2.501-.924 5.053-.903 5.413l.001.01V21a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6.479c.01-.15.03-.592-.001-1.214a1 1 0 1 0-1.998.099c.027.535.009.902.003.996-.002.04-.004.086-.004.137V21H5v-6.461c0-.05-.002-.092-.004-.135-.017-.272-.11-2.452.752-4.524.425-1.02 1.067-1.978 2.032-2.682C8.735 6.5 10.078 6 12 6a1 1 0 1 0 0-2c-.717 0-1.383.06-2 .17V4Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 13a3 3 0 0 1 3-3h2.5a1 1 0 1 1 0 2H9a1 1 0 0 0-1 1v1h8.134a1 1 0 0 1 1.866.5V17a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-4Zm10 3H8v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBackpackBadgePlus;
